"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estimateFee = estimateFee;
exports.estimateFeeAt = estimateFeeAt;

var _types = require("@plugnet/types");

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function estimateFee(api) {
  return (extrinsic, sender) => (0, _rxjs.combineLatest)(api.query.fees.transactionBaseFee(), api.query.fees.transactionByteFee(), api.query.system.accountNonce(sender)).pipe((0, _operators.map)((_ref) => {
    let [baseFee, byteFee, nonce] = _ref;
    return calcFee(baseFee, byteFee, nonce, new _types.Address(sender), extrinsic);
  }));
}

function estimateFeeAt(api) {
  return (hash, extrinsic, sender) => (0, _rxjs.combineLatest)(api.query.fees.transactionBaseFee.at(hash), api.query.fees.transactionByteFee.at(hash), api.query.system.accountNonce.at(hash, sender)).pipe((0, _operators.map)((_ref2) => {
    let [baseFee, byteFee, nonce] = _ref2;
    return calcFee(baseFee, byteFee, nonce, new _types.Address(sender), extrinsic);
  }));
}

const SIGNED_VERSION = 129;

function calcFee(baseFee, byteFee, nonce, sender, extrinsic) {
  const Extrinsic = (0, _types.getTypeRegistry)().get('Extrinsic');
  const clone = new Extrinsic(extrinsic.toHex());
  const signature = clone.signature;
  signature.set('signer', sender);
  signature.set('nonce', new (_types.Compact.with(_types.Index))(nonce));
  signature.set('version', new _types.U8(SIGNED_VERSION));
  return byteFee.muln(clone.encodedLength).add(baseFee);
}